/**
 * Properly encodes an S3 URL while preserving path structure
 * Handles special characters in filenames and paths
 * 
 * @param url The S3 URL to encode
 * @returns The properly encoded URL
 */
export function encodeS3Url(url: string): string {
  if (!url) return '';
  
  // First decode in case it's partially encoded already
  const decodedUrl = decodeURI(url);
  
  // Split by '/' to preserve path structure
  const urlParts = decodedUrl.split('/');
  
  // Don't encode the protocol and domain (first 3 parts)
  const baseUrl = urlParts.slice(0, 3).join('/');
  
  // Encode the rest of the path segments
  const pathParts = urlParts.slice(3).map(part => encodeURIComponent(part));
  
  // Reconstruct the URL
  return baseUrl + '/' + pathParts.join('/');
}

/**
 * Extracts a filename from a URL
 * 
 * @param url The URL to extract the filename from
 * @returns The extracted filename
 */
export function extractFilenameFromUrl(url: string): string {
  if (!url) return '';
  
  const urlParts = url.split('/');
  const lastPart = urlParts[urlParts.length - 1];
  return decodeURIComponent(lastPart);
} 